<template>
  <div class="payrollPayment">
    <van-form label-width="120px">
      <div class="title">{{ $t.payrollList.paymentTitle }}</div>
      <div class="multi-table" v-if="voucherFileList">
        <van-field name="stepper" :label="$t.payrollList.payReceipt" required>
          <template #input>
            <van-stepper
              :min="0"
              :value="voucherFileList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in voucherFileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.VoucherFile))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.VoucherFile"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead1" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.VoucherFile && imgUrlFilter(item.VoucherFile)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.VoucherFile"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>
    </van-form>

    <div class="tool-bar">
      <van-button type="info" block @click="onSubmit">{{ $t.meta.submit }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Uploader, Icon, Image, Stepper } from "vant";

Vue.use(Form).use(Field).use(Button).use(Uploader).use(Icon).use(Image).use(Stepper);

export default {
  name: "payrollPayment",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      OERId: "",
      voucherType: "",
      voucherFileList: [],
      filesIndex: 0,
    };
  },
  created() {
    const { OERId, Type } = this.$route.query;
    this.OERId = OERId;
    this.voucherType = Type;
    this.getOperatingExpenseVoucherList();
  },
  methods: {
    handleAdd() {
      this.voucherFileList.push({
        VoucherFile: "",
      });
    },
    handleDel() {
      if (this.voucherFileList && this.voucherFileList.length > 0) {
        this.voucherFileList.pop();
      }
    },
    handleDelByIndex(index) {
      this.voucherFileList.splice(index, 1);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getOperatingExpenseVoucherList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          VoucherType: this.voucherType,
          OERId: this.OERId,
        };
        this.$api.financialManagement
          .getOperatingExpenseVoucherList(param)
          .then((res) => {
            this.voucherFileList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        OERId: this.OERId,
        VoucherFileList: this.voucherFileList,
      };
      this.$api.financialManagement
        .saveOperatingExpenseVoucher(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.voucherFileList[this.filesIndex].VoucherFile = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.payrollPayment {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
